module.exports = __webpack_public_path__ + "static/img/white_board.fabf932.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/UST/white_board.png
// module id = PDf6
// module chunks = 3